import { css } from 'lit';
import getToken from '../../utils/get-token';
import color from '../../utils/get-color-token';
import { on, transition, typography, disabled } from '../../styles';

function styles() {
	return css`
		:host {
			--m-radio-border-color: ${color('color-border')};
			--m-radio-dot-check-color: ${color('color-primary-60')};
			--m-radio-size: 14px;
			--m-radio-background-color: white;
			--m-radio-border-width: ${getToken('border-thin')};
			--m-radio-label-color: ${color('color-text-tertiary')};
			--m-radio-outline-color: ${color('color-primary-60')};
			--m-radio-outline-offset: 2px;
		}

		.radio-button {
			${typography('body-md')};
			color: var(--m-radio-label-color);

			border: none;
			background: none;

			height: ${getToken('global-height-small')};
			display: inline-flex;
			gap: ${getToken('spacing-1')};
			align-items: center;
			border-radius: ${getToken('border-radius-s')};
			${transition({ property: 'color' })};
		}

		${on.focus('.radio-button')} {
			outline: 1px solid var(--m-radio-outline-color);
			outline-offset: var(--m-radio-outline-offset);
		}

		.radio-button .radio-input {
			width: var(--m-radio-size);
			height: var(--m-radio-size);
			background-color: var(--m-radio-background-color);
			border-color: var(--m-radio-border-color);
			border-width: var(--m-radio-border-width);
			border-style: solid;
			border-radius: 50%;
			position: relative;
			display: inline-flex;

			${transition({ property: 'border-color' })};
		}

		.radio-button .radio-input::before {
			content: '';
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			top: 50%;
			left: 50%;
			display: block;
			position: absolute;
			${transition([
				{ property: 'background-color' },
				{ property: 'height', duration: '120ms' },
				{ property: 'width', duration: '120ms' },
			])};
		}

		.radio-button[aria-checked='true'] .radio-input::before {
			width: 10px;
			height: 10px;
		}

		${disabled('.radio-button')} {
			cursor: default;
			--m-radio-label-color: ${color('color-neutral-40')};
			--m-radio-background-color: ${color('color-background-tertiary')};
		}

		${disabled('.radio-button[aria-checked="true"]', '.radio-input')} {
			--m-radio-border-color: ${color('color-border')};
		}

		${disabled('.radio-button', '.radio-input::before')} {
			--m-radio-dot-check-color: ${color('color-neutral-40')};
		}

		.radio-button .radio-input::before {
			background-color: var(--m-radio-dot-check-color);
		}

		.radio-button[aria-checked='true'] .radio-input {
			--m-radio-dot-check-color: ${color('color-primary-60')};
			--m-radio-border-color: ${color('color-primary-60')};
		}

		.radio-button .radio-input {
			--m-radio-border-color: ${color('color-border')};
		}

		${on.hover('.radio-button')} .radio-input {
			--m-radio-border-color: ${color('color-primary-100')};
			--m-radio-dot-check-color: ${color('color-primary-100')};
		}

		${on.hover('.radio-button')} {
			--m-radio-label-color: ${color('color-text-primary')};
		}

		${disabled('.radio-button', '*')} {
			pointer-event: none;
		}
	`;
}

export default styles;
